import React from 'react';
import { CHANNELS, CHANNEL_LABELS, ChannelType } from '../../../../../types/communication';
import { CHANNEL_VISUALS } from '../shared/channelVisuals';

interface ChannelTabsProps {
    value: ChannelType | '';
    counts: Record<string, number>;
    onChange: (channel: ChannelType | '') => void;
}

const ChannelTabs: React.FC<ChannelTabsProps> = ({ value, counts, onChange }) => {
    const tabs: { key: ChannelType | ''; label: string; icon?: React.ReactNode }[] = [
        { key: '', label: 'Todos' },
        ...CHANNELS.map((c) => {
            const Icon = CHANNEL_VISUALS[c].icon;
            return { key: c, label: CHANNEL_LABELS[c], icon: <Icon size={14} className={CHANNEL_VISUALS[c].text} /> };
        }),
    ];
    return (
        <div className="flex gap-1 shrink-0">
            {tabs.map((tab) => {
                const active = value === tab.key;
                return (
                    <button
                        key={tab.key || 'ALL'}
                        type="button"
                        onClick={() => onChange(tab.key)}
                        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs whitespace-nowrap border transition-colors ${
                            active
                                ? 'bg-slate-800 border-slate-800 text-white dark:bg-slate-100 dark:text-slate-900'
                                : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 text-gray-600 dark:text-gray-300 hover:border-gray-300'
                        }`}
                    >
                        {tab.icon}
                        {tab.label}
                        <span className={`text-xs rounded-full px-1.5 ${active ? 'bg-white/20' : 'bg-slate-100 dark:bg-slate-700 text-gray-500'}`}>
                            {counts[tab.key || 'ALL'] ?? 0}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default ChannelTabs;
